import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import { UsAddressToArrayPipe } from '@domgen/dgx-fe-components/general';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@domgen/dgx-fe-components/list';
import {
  PanelBorderRadius,
  PanelComponent,
} from '@domgen/dgx-fe-components/panel';
import {
  ConjunctionPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { CustomerDetails } from '@us-registration/util-models';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'us-registration-confirmation-customer-details-panel',
  standalone: true,
  imports: [
    DescriptionListComponent,
    DescriptionListItemComponent,
    NgIf,
    PanelComponent,
    TranslatePipe,
    UsAddressToArrayPipe,
    ConjunctionPipe,
  ],
  templateUrl:
    './registration-confirmation-customer-details-panel.component.html',
  styleUrls: [
    './registration-confirmation-customer-details-panel.component.scss',
  ],
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationConfirmationCustomerDetailsPanelComponent {
  @Input() customerDetails?: CustomerDetails;
  @Input() title?: string;
  @Input() variant: Theme = 'background';
  @Input() border = false;
  @Input() rounded?: PanelBorderRadius = 'lg';
  @Input() stacked?: boolean;
}
